import { useStore } from '../store';

/**
 * A seat that may READ the accounting books and never change them: a client's own books login, and the
 * auditor (the house pattern panes already use — CompanyWorkspace/panes/fixedAssets/shared.ts
 * isReadOnlySeat). ⛔ Such a seat is shown no write control at all: the server refuses every write it
 * sends (middleware.ts) and each refusal pages the admins. api.ts refuses a books seat's writes before the
 * network as a net under the screens — not instead of hiding the control.
 */
export const isReadOnlyRole = (role?: string | null): boolean => role === 'books' || role === 'auditor';

/** (Owner 2026-11-03, the one-line merge — rule (b), review round 1) PND.1 / SSO lines: the auditor READS them only where the
 *  company accounting workspace is on (b13 S3 / PAY-6 is a Bangkok-line rule; GET /api/me's `acctWorkspace`, the one
 *  switch). Off, the auditor writes there as on main — the server lets it (middleware.ts), so the panels draw the controls.
 *  A books login stays read-only everywhere (a Daybook-line role main never had). */
export const isPayLinesReadOnly = (me?: { role?: string | null; acctWorkspace?: boolean } | null): boolean =>
  isReadOnlyRole(me?.role) && (me?.role !== 'auditor' || !!me?.acctWorkspace);

/** For components that have no workspace ctx (the classic Bookkeeping pages and the panels they share). */
export function useReadOnlySeat(): boolean {
  return useStore(s => isReadOnlyRole(s.me?.role));
}
